import { createReducer } from 'redux-act';

import {
  WEB_LAYOUT_FETCH, WEB_LAYOUT_FETCH_DATA_SUCCESS, WEB_LAYOUT_FETCH_DATA_FAIL,
  WEB_LAYOUT_DELETE_INIT, WEB_LAYOUT_DELETE_SUCCESS, WEB_LAYOUT_DELETE_FAIL,
  WEB_LAYOUT_CREATE_INIT, WEB_LAYOUT_CREATE_SUCCESS, WEB_LAYOUT_CREATE_FAIL,
  WEB_LAYOUT_MODIFY_INIT, WEB_LAYOUT_MODIFY_SUCCESS, WEB_LAYOUT_MODIFY_FAIL,
  WEB_LAYOUT_CLEAN_UP, WEB_LAYOUT_CLEAR_DATA_LOGOUT,
} from 'state/actions/webLayout';

const initialState = {
  list: [],
  loading: false,
  error: null,
  success: false,
  deleted: false,
  updated: false,
};

export const webLayoutReducer = createReducer(
  {
    [WEB_LAYOUT_FETCH]: (state) => ({ ...state, loading: true, error: null }),
    [WEB_LAYOUT_FETCH_DATA_SUCCESS]: (state, payload) => ({ ...state, list: payload.list || [], loading: false }),
    [WEB_LAYOUT_FETCH_DATA_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error }),
    [WEB_LAYOUT_CREATE_INIT]: (state) => ({ ...state, loading: true, success: false }),
    [WEB_LAYOUT_CREATE_SUCCESS]: (state, payload) => ({ ...state, list: [...state.list, payload.layout], loading: false, success: true }),
    [WEB_LAYOUT_CREATE_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error, success: false }),
    [WEB_LAYOUT_MODIFY_INIT]: (state) => ({ ...state, loading: true, updated: false }),
    [WEB_LAYOUT_MODIFY_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.map((item) => item._id === payload.id ? payload.layout : item),
      loading: false, updated: true,
    }),
    [WEB_LAYOUT_MODIFY_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error, updated: false }),
    [WEB_LAYOUT_DELETE_INIT]: (state) => ({ ...state, loading: true, deleted: false }),
    [WEB_LAYOUT_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((item) => item._id !== payload.id),
      loading: false, deleted: true,
    }),
    [WEB_LAYOUT_DELETE_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error, deleted: false }),
    [WEB_LAYOUT_CLEAN_UP]: (state) => ({ ...state, loading: false, error: null, success: false, deleted: false, updated: false }),
    [WEB_LAYOUT_CLEAR_DATA_LOGOUT]: () => ({ ...initialState }),
  },
  initialState
);
